<template>
  <div class="button-wrapper">
    <Button :secondary="true" sm>Detaya Git</Button>
  </div>
</template>

<script>
import { Button } from '@n11/so-ui-components';

export default {
  name: 'ActionButton',
  components: { Button },
  props: {},
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.button-wrapper {
  width: 80px;

  > button {
    max-height: 24px;
  }
}

</style>
